import { Importer } from 'dashboard/models/importer';
import { ImportersActions, ImportersActionType } from 'dashboard/redux/actions/importers';

export type Importers = Importer[];

export interface ImportersState {
  importers: Importers;
}

const initialState: ImportersState = {
  importers: [],
};

export default (state: ImportersState = initialState, action: ImportersActions) => {
  if (!action || !action.payload) {
    return state;
  }
  switch (action.type) {
    case ImportersActionType.SaveImporterToImporters: {
      return {
        ...state,
        importers: [
          ...state.importers.filter((x) => x.id !== action.payload?.importer.id),
          action.payload?.importer,
        ],
      };
    }
    case ImportersActionType.SaveImporters: {
      return {
        ...state,
        importers: action.payload?.importers,
      };
    }

    default:
      return state;
  }
};
